import ApiService from '../../core/services/ApiService';
import { V1CommonAllergiesGetOneWithOtherTypePayload } from '~/models/schema';

// 選択項目のUIを作成するまでは自由記述を選択していることにするため、IDをハードコーディングする
const ALLERGY_ID = 1000;
const API_V1_ALLERGIES = '/api/v1/user_allergies';

class UserApiService extends ApiService {
  public patchAllergies(allergy: {
    id?: number;
    other: string;
  }): Promise<V1CommonAllergiesGetOneWithOtherTypePayload[]> {
    const data = { usersAllergies: [{ ...allergy, allergyId: ALLERGY_ID }] };
    return this.request(API_V1_ALLERGIES, this.METHOD.PATCH, { data });
  }
}

export default UserApiService;
